import { render } from "./section-header.vue?vue&type=template&id=5664b08c&scoped=true"
import script from "./section-header.vue?vue&type=script&lang=js"
export * from "./section-header.vue?vue&type=script&lang=js"

import "./section-header.vue?vue&type=style&index=0&id=5664b08c&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5664b08c"]])

export default __exports__